<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'
import { useAuthStore } from '~/stores/auth'
import { PARKING_CONSTANTS } from '@/utils/parkingConstants'

definePageMeta({
    middleware: ['redirect'],
    parking: true, // This marks the page as part of the parking world,
    ignoreOnBoarding: true
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Auth store
const authStore = useAuthStore()
const { isLoggedIn } = storeToRefs(authStore)

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.PARKING_HOME,
    loginStatus: isLoggedIn.value ? TRACKING_CONSTANTS.MISC.LOGGED_IN : TRACKING_CONSTANTS.MISC.LOGGED_OUT
})

// Fetch center list items and add placeholder property to each entry
const { data: centers, suspense: centerSuspense } = useFetchCenterList()

onServerPrefetch(async () => {
    await centerSuspense()
})

const parkingCenter = computed(() => centers.value?.find(center => center.uid === centerRoute.value && center.parkingFeatureIsActive))
const hasParkingTicketFeature = computed(() => parkingCenter.value?.productTypes?.includes(PARKING_CONSTANTS.PARKING_TICKET))
const hasMultiPurposeCardFeature = computed(() => parkingCenter.value?.productTypes?.includes(PARKING_CONSTANTS.MULTI_PURPOSE_CARD))

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.parkingfirstpage_headline} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <CenterLogoHeader />
        <ParkingOverviewValueCard v-if="hasParkingTicketFeature || hasMultiPurposeCardFeature" :parking-overview-value-card-config="{ productTypes: center?.productTypes }" />
        <ParkingOverviewPayment v-if="hasParkingTicketFeature" />
        <ParkingOverviewInfos />
        <ParkingOverviewContact />

        <DevOnly><pre>{{ centers }}</pre></DevOnly>
        <DevOnly><pre>{{ parkingCenter }}</pre></DevOnly>
    </PageMainContainer>
</template>
